module.exports = __webpack_public_path__ + "img/IMG_3747.50c16351.jpg";